export default () => ({
  playing: false,
  failed: false,
  reduced: false,
  userPaused: false,
  init() {
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onMotion = () => {
      this.reduced = this.motion.matches;
      if (this.reduced) this.pause();
      else if (!this.userPaused && !document.hidden) this.play();
    };
    this.onVisibility = () => {
      if (document.hidden) this.pause();
      else if (!this.reduced && !this.userPaused) this.play();
    };
    this.motion.addEventListener('change', this.onMotion);
    document.addEventListener('visibilitychange', this.onVisibility);
    this.onMotion();
  },
  async play() {
    if (this.reduced || this.failed) return;
    const video = this.$refs.video;
    if (!video.src) video.src = video.dataset.src;
    video.muted = true;
    try { await video.play(); this.playing = !video.paused; }
    catch { this.playing = false; }
  },
  pause() { this.$refs.video.pause(); this.playing = false; },
  toggle() {
    this.userPaused = this.playing;
    if (this.playing) this.pause(); else this.play();
  },
  destroy() {
    this.pause();
    this.motion.removeEventListener('change', this.onMotion);
    document.removeEventListener('visibilitychange', this.onVisibility);
  },
});
